var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 75,
    width: 75,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68.08 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4521 20.3512C63.7733 16.385 61.3687 12.8221 58.3116 9.75771C55.2546 6.70064 51.6843 4.29603 47.7182 2.61721C43.6128 0.879733 39.2434 0 34.7495 0C28.7966 0 22.9537 1.59085 17.8512 4.59661C12.9541 7.48506 8.85597 11.5905 5.98218 16.495L6.47336 16.7809C12.3383 6.77395 23.1516 0.571827 34.7495 0.571827C52.8133 0.571827 67.5049 15.2634 67.5049 33.3272C67.5049 51.3251 52.9159 65.98 34.9401 66.0826V66.6545C39.3754 66.6325 43.6714 65.7527 47.7255 64.0373C51.6917 62.3584 55.2546 59.9538 58.319 56.8967C61.376 53.8397 63.7807 50.2694 65.4595 46.3033C67.197 42.1979 68.0767 37.8285 68.0767 33.3346C68.0767 28.8406 67.1896 24.4639 65.4521 20.3512Z",
    fill: "#FF3364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4163 33.3274C3.4163 28.5695 4.49397 23.8776 6.56134 19.6329C6.94989 18.8338 6.66398 17.8735 5.89421 17.4336L5.85756 17.4116C5.00715 16.9204 3.92214 17.2503 3.48961 18.1374C2.5439 20.0801 1.78146 22.1035 1.21696 24.1782C0.410542 27.1473 0 30.2264 0 33.3274C0 38.0193 0.916389 42.572 2.7345 46.8533C4.48664 50.9881 6.98655 54.705 10.1829 57.9013C13.3719 61.0904 17.0888 63.5976 21.2309 65.3497C24.7572 66.8379 28.4667 67.725 32.2789 67.9963C33.2612 68.0622 34.0897 67.2925 34.0897 66.3101V66.2734C34.0897 65.3791 33.4005 64.6533 32.5061 64.5873C16.2677 63.4216 3.4163 49.8444 3.4163 33.3274Z",
    fill: "#FF3364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.543 61.086C49.7546 61.086 62.086 48.7546 62.086 33.543C62.086 18.3314 49.7546 6 34.543 6C19.3314 6 7 18.3314 7 33.543C7 48.7546 19.3314 61.086 34.543 61.086Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8036 38.6953C34.8101 38.6953 32.8118 38.6616 30.8183 38.7049C29.2244 38.7434 27.9869 37.7467 27.621 36.1865C26.7109 32.3295 25.7478 28.4821 24.7992 24.6348C24.5729 23.7151 23.9277 23.2046 22.9839 23.1998C22.5409 23.195 22.0931 23.2046 21.6501 23.1998C21.2697 23.195 21 22.9446 21 22.6027C21 22.2609 21.2745 22.0056 21.6597 22.0056C22.2905 22.0105 22.9309 21.9671 23.5521 22.0634C24.78 22.2512 25.5648 23.0024 25.9212 24.1821C26.056 24.6348 26.1619 25.097 26.2631 25.5545C26.3016 25.7423 26.3834 25.7952 26.5664 25.7952C27.7365 25.7856 28.9114 25.7904 30.0864 25.7904C35.8165 25.7904 41.5466 25.7904 47.2768 25.7904C47.3827 25.7904 47.4838 25.7904 47.5898 25.7904C48.0713 25.8049 48.312 26.113 48.2061 26.5849C47.9172 27.8658 47.6235 29.1418 47.3297 30.4227C46.8771 32.4017 46.4293 34.3808 45.967 36.3551C45.6396 37.7707 44.5273 38.676 43.0779 38.6856C40.9832 38.7049 38.8934 38.6904 36.8036 38.6953ZM26.6338 27.0087C26.6579 27.1194 26.6724 27.2109 26.6964 27.3024C27.4091 30.206 28.1217 33.1144 28.8296 36.018C29.0655 36.9907 29.7011 37.4963 30.6979 37.4963C34.7716 37.4963 38.8453 37.4963 42.9238 37.4963C43.9735 37.4963 44.5995 36.9907 44.8306 35.965C45.2929 33.9426 45.7551 31.9154 46.2222 29.893C46.4389 28.9396 46.6604 27.9814 46.8819 27.0087C40.1261 27.0087 33.3992 27.0087 26.6338 27.0087Z",
    fill: "#FF3364",
    stroke: "#FF3364",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6626 43.3083C29.6674 41.8252 30.8809 40.6214 32.3543 40.6359C33.8422 40.6503 35.0268 41.8541 35.0172 43.342C35.0075 44.8155 33.8085 46 32.3399 46C30.8568 46 29.6578 44.7962 29.6626 43.3083ZM30.8616 43.3228C30.8616 44.1414 31.5261 44.8059 32.3399 44.8059C33.1537 44.8059 33.8182 44.1365 33.8182 43.3228C33.8182 42.5042 33.1585 41.8493 32.3399 41.8493C31.5117 41.8445 30.8616 42.4946 30.8616 43.3228Z",
    fill: "#FF3364",
    stroke: "#FF3364",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1404 43.3178C43.1404 44.8058 41.9415 46.0047 40.4584 45.9999C38.9753 45.9951 37.7811 44.7913 37.7859 43.3034C37.7907 41.8348 38.9849 40.6406 40.4535 40.6358C41.9366 40.6309 43.1404 41.8348 43.1404 43.3178ZM41.9415 43.3323C41.9463 42.5041 41.301 41.8492 40.4776 41.8444C39.6542 41.8396 38.9897 42.4896 38.9849 43.3082C38.9801 44.122 39.6398 44.7961 40.4535 44.8058C41.2625 44.8106 41.9366 44.1461 41.9415 43.3323Z",
    fill: "#FF3364",
    stroke: "#FF3364",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_151_8692",
    x: 0.230946,
    y: 1.83129,
    width: 87.1702,
    height: 87.1705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.06667,
    dy: 12.0889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.55556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_151_8692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_151_8692",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_151_8692",
    x1: 52.4732,
    y1: 55.6091,
    x2: 17.0231,
    y2: 11.0416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms_icon.5949b952e4dc68d654d02651cbd71517.svg";
export { ForwardRef as ReactComponent };